module.exports = __webpack_public_path__ + "static/media/4362.b20ea2cc.jpg";